import Api from "..";
import PrivateUser from "../../dtos/user";
import {
  UserOtpRegenerateInput,
  UserOtpResponse,
  UserOtpValidateInput,
} from "../../dtos/user/otp";
import transform from "../../service/transform";

export default class OtpUserApi extends Api {
  constructor() {
    super("user/otp");
  }

  public async get(
    id: null | undefined,
    params: UserOtpRegenerateInput
  ): Promise<UserOtpResponse> {
    return await transform(UserOtpResponse)(
      (
        await super.get(undefined, params)
      ).data
    );
  }

  public async post(data: UserOtpValidateInput): Promise<PrivateUser> {
    return await transform(PrivateUser)((await super.post(data)).data);
  }
}
